import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconHome = ({ className = '', color = '#000000', height = 18, title, width = 20 }: Icon) => (
    <AccessibleSVG className={`icon-home ${className}`} height={height} title={title} viewBox="0 0 20 18" width={width}>
        <path className="fill-color" d="M8 17.5v-6h4v6h5v-8h3l-10-9-10 9h3v8h5z" fill={color} fillRule="evenodd" />
    </AccessibleSVG>
);

export default IconHome;
